import { isRecord } from "utils/isRecord";

export const SCOUT_ENCAMP_REPRESENTATIVE_TOOL_NAME = "present_encamp_representative";

export type EncampRepresentative = {
  cardId: string;
};

function readString(value: Record<string, unknown>, key: string): string | undefined {
  const candidate = value[key];
  return typeof candidate === "string" ? candidate : undefined;
}

export function parseEncampRepresentative(output: unknown): EncampRepresentative | null {
  if (!isRecord(output)) return null;
  if (output.kind !== "encamp_representative") return null;
  const cardId = readString(output, "cardId");
  if (!cardId) return null;
  return { cardId };
}
